var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",attrs:{"src":_vm.html,"height":"100%","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }